module.exports = __webpack_public_path__ + "static/media/logoNPM.8f5c7818.svg";